export interface Language {
  code: string
  name: string
  flag: string
}

export const AVAILABLE_LANGUAGES: Language[] = [
  { code: 'de', name: 'German - DE', flag: '🇩🇪' },
  { code: 'dk', name: 'Danish - DK', flag: '🇩🇰' },
  { code: 'en', name: 'English - EN', flag: '🇬🇧' },
  { code: 'es', name: 'Spanish - ES', flag: '🇪🇸' },
  { code: 'ee', name: 'Estonian - EE', flag: '🇪🇪' },
  { code: 'fr', name: 'French - FR', flag: '🇫🇷' },
  { code: 'it', name: 'Italian - IT', flag: '🇮🇹' },
  { code: 'lt', name: 'Lithuanian - LT', flag: '🇱🇹' },
  { code: 'lv', name: 'Latvian - LV', flag: '🇱🇻' },
  { code: 'nl', name: 'Netherlands - NL', flag: '🇳🇱' },
  { code: 'pl', name: 'Polish - PL', flag: '🇵🇱' },
  { code: 'pt', name: 'Portuguese - PT', flag: '🇵🇹' },
  { code: 'ru', name: 'Russian - RU', flag: '🇷🇺' },
  { code: 'sk', name: 'Slovak - SK', flag: '🇸🇰' },
]

export interface EnabledLanguage {
  id?: number
  createdAt?: string
  updatedAt?: string
  language: string
  web_address_enabled: boolean
  web_address: string
  google_analytics: string
  google_tag_manager: string
  facebook_pixel: string
  facebook_page_id: string
  hotjar: string
  tawk_to_widget_id: string
  enable_language_switcher: boolean
  price_multiplier: number
  shop_phone_number: string
  default_language: boolean
}

export const createDefaultEnabledLanguage = (
  languageCode: string
): Omit<EnabledLanguage, 'id' | 'createdAt' | 'updatedAt'> => ({
  language: languageCode,
  web_address_enabled: false,
  web_address: '',
  google_analytics: '',
  google_tag_manager: '',
  facebook_pixel: '',
  facebook_page_id: '',
  hotjar: '',
  tawk_to_widget_id: '',
  enable_language_switcher: true,
  price_multiplier: 1,
  shop_phone_number: '',
  default_language: false,
})
